import { Component } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";







@Component({
    templateUrl: './form-datepicker.component.html',
    styleUrl: './form-datepicker.component.css',
    imports: [FormsModule, ReactiveFormsModule, FormlyModule]
})
export class FormDatePickerComponent extends FieldType {
  get control(): FormControl {
    return this.formControl as FormControl;
  }

}
